import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseResponse, ValidatePhoneDto } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { validatePhoneUrl } from './phone-api.constant';

@Injectable({
  providedIn: 'root',
})
export class PhoneApiService {
  private readonly http = inject(HttpClient);

  validatePhone(phone: string): Observable<BaseResponse<ValidatePhoneDto>> {
    return this.http.get<BaseResponse<ValidatePhoneDto>>(validatePhoneUrl(), {
      params: { phone },
    });
  }
}
